export default {
  title: [
    { required: true, message: 'O título é obrigatório.', trigger: 'blur' },
    { min: 5, max: 190, message: 'O título deve ter entre 5 e 190 caracteres.', trigger: 'blur' }
  ],
}
